import * as types from "../types";

const initialState = {
  loading: false,
  fuelModel: null,
  requestDevice: null,
  error: null,
};

export default function fetchFuelModelReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_FUEL_MODEL_REQUEST:
      return {
        ...state,
        loading: true,
        requestDevice: action.payload.requestDevice,
      };

    case types.FETCH_FUEL_MODEL_SUCCESS:
      return {
        ...state,
        loading: false,
        fuelModel: action.payload.fuelModel,
      };

    case types.FETCH_FUEL_MODEL_FAILURE:
      return {
        ...state,
        loading: false,
        fuelModel: null,
        requestDevice: null,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
